<template>
  <div class="dialog-container wt-dialog-container">
    <div>
      <div class="tab-info-card">
        <div class="user-detail">
          <div class="tab-info-title">基本信息</div>
          <div class="tab-info-content tab-base">
            <div class="tab-base-item">
              <span class="tab-base-label">用户昵称：</span>
              <span class="tab-base-value">{{ detailFormData.nickName }}</span>
            </div>
        <!--    <div class="tab-base-item">
              <span class="tab-base-label">用户姓名：</span>
              <span class="tab-base-value">{{ detailFormData.name }}</span>
            </div> -->
            <div class="tab-base-item">
              <span class="tab-base-label">创建时间：</span>
              <span class="tab-base-value">{{ detailFormData.createTime }}</span>
            </div>
          </div>
        </div>
      </div>
      <!-- tab内容 -->
      <div class="tab-info-card">
        <div class="tab-info-title">详情信息</div>
        <div class="tab-info-content">
          <div>{{ detailFormData.content }}</div>
          <template v-if="detailFormData.feedbackImg">
            <template v-for="(item, index) in imgArr">
              <el-image
                style="width: 100px; height: 100px"
                :src="item"
                :key="index"
                :z-index="999"
                fit="cover"
                class="image-cover"
                :preview-src-list="[item]">
              </el-image>
            </template>

          </template>
        </div>
      </div>
      <wt-detail-form-buttons :detail-form-buttons.sync="detailFormButtons" @on-detail-button-action="onDetailButtonAction"></wt-detail-form-buttons>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'Feedback-view',
  props: ['component-type'],
  isAutoComponent: true,
  data() {
    return {
      imgUrl: window.wtConst.FILE_SERVER_URL,
      formCode: 'MODULES_USERMESSAGE',
      isSubmitLoading: false,
      detailFormButtons: {
        title: '',
        elements: [{ name: '返回', key: 'CLOSE', action: 'CLOSE' }]
      },
      imgArr: []
    }
  },
  created() {
    this.$store.dispatch('appendBreadcrumb', { meta: { title: '意见详情' }})
    if (this.detailFormData.feedbackImg) {
      var _imgArr = this.detailFormData.feedbackImg.split(',')
      for (const item of _imgArr) {
        this.imgArr.push(this.imgUrl + item)
      }
      console.log(_imgArr, _imgArr.length)
      console.log(this.imgArr, this.imgArr.length)
    }
  },
  methods: {
    /*  ------------------------- 按钮  -------------------------  */
    onDetailButtonAction(item) {
      if (item.action === 'CLOSE') {
        this.$emit('on-dialog-action', 'close')
        this.$store.dispatch('removeBreadcrumb')
      }
    }
  },
  computed: {
    ...mapState({
      detailFormData: state => state.feedback.feedbackDetailData
    })
  }
}
</script>

<style lang="scss" scoped>
.user-info-card {
  .user-detail {
    background: #fff;
    .user-detail-top {
      display: flex;
      align-items: center;
      padding: 20px;
    }
    .user-detail-photo {
      width: 48px;
      height: 48px;
      border: 1px solid #666;
      border-radius: 50%;
      margin-right: 16px;
    }
    .user-detail-username {
      font-size: 20px;
      font-weight: 500;
      line-height: 20px;
      color: #333;
      margin-right: 16px;
    }
    .user-detail-level {
      padding: 2px 8px;
      font-size: 12px;
      line-height: 14px;
      border: 1px solid rgba(204, 204, 204, 1);
      color: #666;
    }
    .user-detail-bottom {
      display: flex;
      align-items: center;

    }
    .user-detail-label {
      margin-left: 84px;
      color: #989898;
    }
    .user-detail-value {
      color: #666666;
    }
  }
}
.tab-info-title {
  padding: 20px;
  border-bottom: 1px solid rgba(228, 228, 228, 1);
  font-size: 16px;
  font-weight: 600;
  color: #444;
}
.tab-info-card {
  margin-top: 20px;
  background: #fff;

  .tab-base {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    .tab-base-item {
      display: flex;
      align-items: center;
      width: 400px;
      margin-bottom: 20px;
    }
    .tab-base-label {
      width: 100px;
      text-align: right;
      color: #989898;
    }
    .tab-base-value {
      color: #666666;
    }
  }
  .tab-info-content {
    padding: 20px;
    line-height: 26px;
    img {
      margin-top: 20px;
    }
  }
}
.tab-info-padding {
  padding: 20px;
}
.image-cover {
  margin-right: 20px;
}
</style>
<style lang="scss">
.user-info-card {
  .el-tabs__header {
    margin-bottom: 0;
    .el-tabs__item.is-active {
      color: #108ee9;
    }
  }
  .el-tabs--top .el-tabs__item.is-top:nth-child(2) {
    padding-left: 20px;
  }
  .el-tabs {
    margin-top: 20px;
  }
}
</style>
